<template>
    <!--News One Start-->
    <section class="news-one">
            <div class="container">
                <div class="section-title text-center">
                    <!-- <span class="section-title__tagline">News & articles</span> -->
                    <h2 class="section-title__title"> Otros Servicios</h2>
                </div>
                <div class="row">
                    <!--News One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                        <div class="news-one__single">
                            <div class="news-one__img">
                                <img src="assets/images/homeFotos/otherService.jpg" alt="">
                            </div>
                            <div class="news-one__content-box">
                                <div class="news-one__content-inner">
                                    <div class="news-one__content">
                                        <ul class="list-unstyled news-one__meta">
                                            <!-- <li><a href="news-details.html"><i class="far fa-user-circle"></i> Admin</a>
                                            </li> -->
                                            <!-- <li><a href="news-details.html"><i class="fas fa-comments"></i> 2
                                                    Comments</a>
                                            </li> -->
                                        </ul>
                                        <h3 class="news-one__title"><a href="#">Sistema de Riego Iot</a></h3>
                                    </div>
                                    <!-- <div class="news-one__bottom">
                                        <div class="news-one__read-more">
                                            <a href="news-details.html"> <span class="icon-right-arrow"></span> Read
                                                More</a>
                                        </div>
                                        <div class="news-one__share">
                                            <a href="#"><i class="fas fa-share-alt"></i></a>
                                        </div>
                                    </div> -->
                                    <div class="news-one__social-box">
                                        <ul class="list-unstyled news-one__social">
                                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="#"><i class="fab fa-dribbble"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="news-one__date">
                                    <p>23 May, 2022</p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <!--News One Single End-->
                    <!--News One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                        <div class="news-one__single">
                            <div class="news-one__img">
                                <img src="assets/images/homeFotos/otherService1-2.jpg" alt="">
                            </div>
                            <div class="news-one__content-box">
                                <div class="news-one__content-inner">
                                    <div class="news-one__content">
                                        <!-- <ul class="list-unstyled news-one__meta">
                                            <li><a href="news-details.html"><i class="far fa-user-circle"></i> Admin</a>
                                            </li>
                                            <li><a href="news-details.html"><i class="fas fa-comments"></i> 2
                                                    Comments</a>
                                            </li>
                                        </ul> -->
                                        <h3 class="news-one__title"><a href="#">Instalaciones Hidráulicas</a></h3>
                                    </div>
                                    <!-- <div class="news-one__bottom">
                                        <div class="news-one__read-more">
                                            <a href="news-details.html"> <span class="icon-right-arrow"></span> Read
                                                More</a>
                                        </div>
                                        <div class="news-one__share">
                                            <a href="#"><i class="fas fa-share-alt"></i></a>
                                        </div>
                                    </div> -->
                                    <div class="news-one__social-box">
                                        <ul class="list-unstyled news-one__social">
                                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="#"><i class="fab fa-dribbble"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="news-one__date">
                                    <p>23 May, 2022</p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <!--News One Single End-->
                    <!--News One Single Start-->
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
                        <div class="news-one__single">
                            <div class="news-one__img">
                                <img src="assets/images/homeFotos/otherService3.jpg" alt="">
                            </div>
                            <div class="news-one__content-box">
                                <div class="news-one__content-inner">
                                    <div class="news-one__content">
                                        <!-- <ul class="list-unstyled news-one__meta">
                                            <li><a href="news-details.html"><i class="far fa-user-circle"></i> Admin</a>
                                            </li>
                                            <li><a href="news-details.html"><i class="fas fa-comments"></i> 2
                                                    Comments</a>
                                            </li>
                                        </ul> -->
                                        <h3 class="news-one__title"><a href="#">Instalaciones Eléctricas</a></h3>
                                    </div>
                                    <!-- <div class="news-one__bottom">
                                        <div class="news-one__read-more">
                                            <a href="news-details.html"> <span class="icon-right-arrow"></span> Read
                                                More</a>
                                        </div>
                                        <div class="news-one__share">
                                            <a href="#"><i class="fas fa-share-alt"></i></a>
                                        </div>
                                    </div> -->
                                    <div class="news-one__social-box">
                                        <ul class="list-unstyled news-one__social">
                                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="#"><i class="fab fa-dribbble"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="news-one__date">
                                    <p>23 May, 2022</p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <!--News One Single End-->
                </div>
            </div>
        </section>
        <!--News One End-->
        <a href="#" data-target="html" class="scroll-to-target scroll-to-top"><i class="icon-up-arrow"></i></a>
  
  </template>
    <style>
        .news-one__img img {
            height: 500px !important;
        }
        .news-one {
            padding: 20px 0 60px !important;
        }

        @media only screen and (max-width: 1024px){
            .news-one {
                margin-bottom: 214px;
            }

            .news-one__title{
                font-size: 28px;
            }
        }
        @media only screen and (max-width: 768px){
            .news-one__img img {
                height: auto !important;
            }
            
            .news-one {
                margin-bottom: 0px;
            }

            .news-one__title{
                font-size: 40px;
            }
        }   
        @media only screen and (max-width: 414px){
            .news-one__title{
                font-size: 26px;
            }
        }
        @media only screen and (max-width: 320px){
            .news-one__title{
                font-size: 21px;
            }
        }      
    </style>
  <script>
    export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                if ($(".scroll-to-top").length) {
                var strickyScrollPos = 100;
                if ($(window).scrollTop() > strickyScrollPos) {
                    $(".scroll-to-top").fadeIn(500);
                } else if ($(this).scrollTop() <= strickyScrollPos) {
                    $(".scroll-to-top").fadeOut(500);
                }
                }
                        
            }
        }
    }
  </script>